__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "oceantech-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@oceantech/oceantech-ui", "0.9.17-rc6", () => (Promise.all([__webpack_require__.e(93), __webpack_require__.e(4253), __webpack_require__.e(5728), __webpack_require__.e(9428), __webpack_require__.e(8314), __webpack_require__.e(6672), __webpack_require__.e(8081), __webpack_require__.e(2251), __webpack_require__.e(8735), __webpack_require__.e(6375), __webpack_require__.e(6989), __webpack_require__.e(6858), __webpack_require__.e(709), __webpack_require__.e(9186), __webpack_require__.e(6122), __webpack_require__.e(1489), __webpack_require__.e(5676), __webpack_require__.e(1909), __webpack_require__.e(5813), __webpack_require__.e(6917), __webpack_require__.e(1998), __webpack_require__.e(3505)]).then(() => (() => (__webpack_require__(59186))))));
			register("axios", "0.26.1", () => (__webpack_require__.e(5133).then(() => (() => (__webpack_require__(45133))))));
			register("formik", "2.2.9", () => (Promise.all([__webpack_require__.e(4203), __webpack_require__.e(6122)]).then(() => (() => (__webpack_require__(74203))))));
			register("react-dom", "18.0.0", () => (Promise.all([__webpack_require__.e(6599), __webpack_require__.e(6122)]).then(() => (() => (__webpack_require__(86599))))));
			register("react-intl", "5.25.0", () => (Promise.all([__webpack_require__.e(3215), __webpack_require__.e(8796), __webpack_require__.e(6122)]).then(() => (() => (__webpack_require__(68796))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(4714), __webpack_require__.e(6122), __webpack_require__.e(1909), __webpack_require__.e(4942)]).then(() => (() => (__webpack_require__(1314))))));
			register("react-router", "6.3.0", () => (Promise.all([__webpack_require__.e(4714), __webpack_require__.e(6122), __webpack_require__.e(8000)]).then(() => (() => (__webpack_require__(10361))))));
			register("react", "18.0.0", () => (__webpack_require__.e(390).then(() => (() => (__webpack_require__(50390))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};